import { gql } from '@apollo/client'

export const NOTIFICATION_FIELDS = gql`
  fragment NotificationFields on Notification {
    id
    kind
    actionKind
    actionButtonLabel
    dismissButtonLabel
    screen
    icon
    style
    content
    payload
    title
    imageUrl
    deliveredAt
    canceledAt
    dismissedAt
    completedAt
    readAt
    createdAt
    updatedAt
    inboxVisible
    templateKind
    priority
    sticky
  }
`
